export const refunds = [
    {
        id: 0,
        product: "ETH Lido Farm",
        category: "0x3423432232342342",
        image: "/images/content/lido.jpg",
        image2x: "/images/content/lido.jpg",
        status: true,
        link: "www.lido.fi",
        date: "13 Sep",
        man: "rene.eth",
        avatar: "/images/content/avatar-1.jpg",
        parameters: [
            {
                title: "Minimum Borrow",
                content: "0.00 ETH",
            },
            {
                title: "Borrow Amount",
                content: "50 ETH",
            },
            {
                title: "Available Funds",
                content: "0.00 ETH",
            },
            {
                title: "Estimated APY",
                content: "12.34%",
                tooltip: "Variable APY",
                downloadedStatus: true,
                downloadedValue: true,
            },
            {
                title: "Estimated Rewards",
                content: "0.00 ETH",
            },
            {
                title: "Opening Transaction Cost",
                price: 0.123,
            },
        ],
        details: [
            {
                title: "Position Amount",
                content: "3.00 ETH",
            },
            {
                title: "Leverage Loop Level",
                content: "2x",
            },
            {
                title: "Borrow Amount",
                content: "4.00 ETH",
            },
            {
                title: "Current APY",
                content: "12.34%",
                downloadedStatus: true,
                downloadedValue: true,
            },
            {
                title: "Estimated Rewards",
                content: "0.00 ETH",
            },
            {
                title: "Closing Transaction Cost",
                tooltip: "Description Price",
                price: 0.123,
            },
        ],
    },
    {
        id: 1,
        product: "WETH Loan Doodles",
        category: "0x232834234723",
        image: "/images/content/product-pic-2.jpg",
        image2x: "/images/content/product-pic-2@2x.jpg",
        status: false,
        date: "12 Sep",
        man: "foon.eth",
        avatar: "/images/content/avatar-2.jpg",
        parameters: [
            {
                title: "Request send",
                content: "Aug 20, 2023",
            },
            {
                title: "Reason",
                content: "Download link is broken",
            },
            {
                title: "Product downloaded",
                downloadedStatus: true,
                downloadedValue: false,
            },
            {
                title: "Purchase date",
                content: "July 01, 2023",
            },
            {
                title: "Purchase code",
                content: "6373ads-hd73h-8373DS",
            },
            {
                title: "Request ID",
                content: "8975ads-hd73h-8974DS",
            },
            {
                title: "Market fee",
                tooltip: "Description Market fee",
                price: 7.28,
            },
            {
                title: "Price",
                tooltip: "Description Price",
                price: 72.88,
            },
        ],
    },
];
